var _rect, _path, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDraftCreated = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  x: 2,
  y: 2,
  fill: "currentColor",
  fillOpacity: 0.2,
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillOpacity: 0.3,
  d: "M7 7h10v2l-1 5-1-5H9v6l5 1-5 1H7z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  x: 6.5,
  y: 14.5,
  fill: "currentColor",
  rx: 1.5
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  x: 14.5,
  y: 6.5,
  fill: "currentColor",
  rx: 1.5
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  x: 6,
  y: 6,
  fill: "currentColor",
  rx: 2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDraftCreated);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNCIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNNyA3SDE3VjlMMTYgMTRMMTUgOUg5VjE1TDE0IDE2TDkgMTdIN1Y3WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuMyIvPgo8cmVjdCB4PSI2LjUiIHk9IjE0LjUiIHdpZHRoPSIzIiBoZWlnaHQ9IjMiIHJ4PSIxLjUiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cmVjdCB4PSIxNC41IiB5PSI2LjUiIHdpZHRoPSIzIiBoZWlnaHQ9IjMiIHJ4PSIxLjUiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cmVjdCB4PSI2IiB5PSI2IiB3aWR0aD0iNCIgaGVpZ2h0PSI0IiByeD0iMiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";